import React from 'react';
import { GIButton, Modal } from 'app-components';
import { FormattedMessage } from 'react-intl';
import { StyledModal } from '../constants/ticketlist.styled';
import { ICancelTicketModal } from '../constants/ticketlist.interface';

export const CancelTicketModal = ({ onClose, onCancelTicketReasonOpen }: ICancelTicketModal) => {
    const onSubmit = () => {
        onClose();
        onCancelTicketReasonOpen();
    };

    return (
        <StyledModal>
            <Modal id="cancelTicketModal" data-testid="cancel-ticket-modal">
                <Modal.Header
                    id="cancelTicketModalHeader"
                    titleId="ticketList.modal.cancelTicket.header"
                    data-testid="cancel-ticket-modal-header"
                    onHide={onClose}
                />
                <Modal.Body data-testid="cancel-ticket-modal-body">
                    <FormattedMessage id="ticketList.modal.cancelTicket.body" />
                </Modal.Body>
                <Modal.Controls data-testid="cancel-ticket-modal-controls">
                    <GIButton
                        id="cancelTicketModalNoButton"
                        onClickHandler={onClose}
                        variant="secondary"
                        labelId="button.no"
                    />
                    <GIButton
                        id="cancelTicketModalYesButton"
                        onClickHandler={onSubmit}
                        variant="primary"
                        labelId="button.yes"
                    />
                </Modal.Controls>
            </Modal>
        </StyledModal>
    );
};


